import React from "react";
import { Button, Flex, notification, Popconfirm, Row, Tag } from "antd";
import { Space, Title } from "./SingleOrderHeader.styled";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { useMode } from "../../organisms";
import { useMutation } from "@apollo/client/react";
import { DELETE_ITEM, GET_ITEMS } from "../../../graphql/items";
import {
  getPayrollDeleteMutation,
  getPayrollListQueryName,
} from "../../../graphql/payroll";

export const SingleOrderHeader: React.FC<{
  title: string;
  labels: any;
  id: any;
  delete_permission: any;
  delete_url?: string;
  item?: any[];
}> = ({ title, labels, id, delete_permission, delete_url, item }) => {
  const { mode, setMode, dataType } = useMode();

  const hasEditableFields = React.useMemo(() => {
    const checkWriteable = (controls: any[]): boolean => {
      return controls.some((c) => {
        if (c.writeable !== false) return true;
        if (Array.isArray(c.children)) return checkWriteable(c.children);
        return false;
      });
    };
    return checkWriteable(item || []);
  }, [item]);

  const deleteMutation = getPayrollDeleteMutation(dataType) ?? DELETE_ITEM;
  const refetchQueryName = getPayrollListQueryName(dataType) ?? "Items";

  const [deleteItem, { loading: isLoading }] = useMutation(deleteMutation, {
    refetchQueries: [refetchQueryName],
    onCompleted: () => {
      notification.success({
        message: "Usunięto pomyślnie",
        style: {
          background: "#52c41a30",
        },
      });
      setMode("read");
    },
    onError: () => {
      notification.error({
        message: "Błąd uswania",
        style: {
          background: "#ff4d4f30",
        },
      });
    },
  });

  const mutateAsync = async (args: { id: any; delete_url?: string }) => {
    await deleteItem({ variables: { id: Number(args.id) } });
  };

  return (
    <Row justify="space-between">
      <Space size={"small"} direction="vertical">
        {!!title && (
          <Tag color="#17a2b8">
            <Title level={4} copyable>
              {title}
            </Title>
          </Tag>
        )}
        <Space size={"small"} direction="horizontal">
          {labels?.map((e: any) => {
            return (
              <Tag color={e?.color} key={e?.text}>
                {e?.text}
              </Tag>
            );
          })}
        </Space>
      </Space>
      <Flex gap={8}>
        <Popconfirm
          title="Usuń pozycje"
          description="Czy na pewno chcesz usunąć wybraną pozycję?"
          onConfirm={() => mutateAsync({ id, delete_url })}
          okText="Tak"
          cancelText="Nie"
        >
          <Button
            loading={isLoading}
            disabled={mode === "edit" || !delete_permission}
            shape="circle"
            danger
            icon={<DeleteOutlined />}
            size={"large"}
          />
        </Popconfirm>
        {hasEditableFields && (
          <Button
            disabled={isLoading}
            onClick={() => setMode(mode === "read" ? "edit" : "read")}
            type={mode === "read" ? "dashed" : "link"}
            shape="circle"
            icon={<EditOutlined />}
            size={"large"}
          />
        )}
      </Flex>
    </Row>
  );
};
